import React from 'react';
import { useNavigate } from 'react-router-dom';

import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';

import useAnalytics from '../../../../useAnalytics';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const Back = ({ onBackClick }: { onBackClick: () => void }) => {
  const navigate = useNavigate();
  const { logEvent } = useAnalytics();
  const handleBack = () => {
    logEvent('Applications back button clicked', {
      flush: true,
    });
    onBackClick();
    navigate('/');
  };

  return (
    <NavLink
      icon={faChevronLeft}
      iconClassName={styles.BackButtonIcon}
      iconContainerClassName={styles.BackButton}
      textClassName={styles.BackButtonText}
      copy="Applications"
      onClick={handleBack}
    />
  );
};

export default Back;
